import {
  FormatType,
  OfficeLocation,
  SortType,
  clearSortAndFilterEvents,
  filterAndSortEvents,
  getAllEvents,
} from "../../actions/eventsActions";

import { EventsState } from "../../../types/redux";
import _ from "lodash";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: null,
  success: false,
  data: [],
  sortType: SortType.DATE_SOONEST,
  eventFilters: {
    office: OfficeLocation.NEW_ENGLAND,
    format: FormatType.ALL,
    eventTags: ["All"],
  },
} as EventsState;

const eventsSlice = createSlice({
  name: "events",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllEvents.fulfilled, (state, action) => {
      state.loading = false;
      state.success = true;
      state.error = null;
      if (!_.isEqual(state.data, action.payload.result)) {
        state.data = action.payload.result;
      }
    });
    builder.addCase(getAllEvents.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllEvents.rejected, (state, action) => {
      state.loading = false;
      state.success = false;
      state.error = action.payload;
      state.data = [];
    });
    builder.addCase(filterAndSortEvents.fulfilled, (state, action) => {
      state.loading = false;
      state.success = true;
      state.sortType = action.payload.sortBy;
      state.eventFilters.format = action.payload.filters.format;
      state.eventFilters.office = action.payload.filters.office;
      state.eventFilters.eventTags = action.payload.filters.eventTags;
    });
    builder.addCase(clearSortAndFilterEvents, (state) => {
      state.sortType = initialState.sortType;
      state.eventFilters.format = initialState.eventFilters.format;
      state.eventFilters.office = initialState.eventFilters.office;
      state.eventFilters.eventTags = initialState.eventFilters.eventTags;
    });
  },
});

export default eventsSlice.reducer;
